/**
 * Reads the Routine Builder kill switch. False when the setting is absent or disabled.
 *
 * @returns {boolean}
 */
const isRoutineBuilderKillswitchEnabled = () => !!Sephora.configurationSettings?.genAIChatBotRoutineBuilder?.isEnabled;

/**
 * Whether this client can render the Routine Builder routine block. Sent on every
 * chat request so the backend only returns a routine to clients that opted in.
 *
 * @returns {boolean}
 */
const selectRoutineBuilderEnabled = () => isRoutineBuilderKillswitchEnabled();

export {
    selectRoutineBuilderEnabled, isRoutineBuilderKillswitchEnabled
};
